export interface IOrderAccount {
    account_id: number;
    account_name: string;
    account_description: string;
    created_at: Date;
    updated_at: Date;
    created_by: number;
    updated_by: number;
}

export class OrderAccount implements IOrderAccount {
    account_description!: string;
    created_at!: Date;
    updated_at!: Date;
    created_by!: number;
    updated_by!: number;
    account_id!: number;
    account_name!: string;
}

export class OrderSearchTool {
  order_number!: number;
  contact_id!: number;
  from_date!: Date;
  to_date!: Date;
  order_by = 'order_date';
  order_type = 'desc';
}
